import * as Updates from 'expo-updates'

export default Updates
